// extracted by mini-css-extract-plugin
module.exports = {"effectsGrayscale":"SvSjS","effectsGrayscale30":"H7zVv","resetList":"_2lYmr","button":"_2k1zM","iconWrapper":"_2MYAL","isFacebook":"_3W2yc","title":"_2xmw7"};